import { render, staticRenderFns } from "./Carousel4Slide.vue?vue&type=template&id=8ba1a14e&scoped=true&"
import script from "./Carousel4Slide.vue?vue&type=script&lang=js&"
export * from "./Carousel4Slide.vue?vue&type=script&lang=js&"
import style0 from "./Carousel4Slide.vue?vue&type=style&index=0&id=8ba1a14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba1a14e",
  null
  
)

export default component.exports